<template>
  <div class="wrapper-full" :style="`overflow:hidden`">
    <div ref="scrollerlist" class="data-wrapper">
      <div>
        <div style="width: 100%" v-for="(item, index) in photosList" :key="index + ''">
          <ImageItem
            v-if="item && item.originalname"
            :imagename="item.originalname"
            :dispH="dispH"
            :id="index"
            :thumbnail="item.thumbnail"
            @select="selectItem"
            :currentid="currentid"
            :photos="photos"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ImageItem from "./ImageItem";
import BScroll from "better-scroll";
import { Size, SubPageSize } from "../../../mixins";
export default {
  name: "ImageList",
  data() {
    return {
      bscroll: undefined,
      currentid: 0,
      photosList: []
    };
  },
  mixins: [Size, SubPageSize],
  components: {
    ImageItem
  },
  mounted() {
    this.$nextTick(() => {
      if (this.photos && this.photos.length > 0) {
        this.initBscroll();
        // this.photosList = this.photos.length > 1 && this.photos[1] ? this.photos : [this.photos[0]]
        this.photosList = this.photos;
      }
    });
  },
  props: {
    photos: Array,
    dispH: Number
  },
  methods: {
    initBscroll() {
      this.bscroll = new BScroll(this.$refs.scrollerlist, {
        scrollY: true,
        mouseWheel: true,
        disableMouse: false,
        disableTouch: false,
        bounce: false,
        click: true
      });
    },
    selectItem(id) {
      this.currentid = id;
      this.$emit("changeShowItem", id);
    }
  },
  watch: {
    photos(newValue, oldValue) {
      this.photosList = newValue;
    }
  }
};
</script>
<style lang="less" scoped>
.data-wrapper {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/basic/ImageList.vue